module.exports = __webpack_public_path__ + "img/insta.b178b78b.svg";